import Flickity from 'flickity';

class CardCarousel {
	constructor(passedElement) {
		let self = this;

		self.elem = passedElement;
		self.flktyCarousel = null;
	}

	init() {
		let self = this;

		self.prevBtn = self.elem.nextElementSibling.querySelector('.js-card-carousel-prev');
		self.nextBtn = self.elem.nextElementSibling.querySelector('.js-card-carousel-next');
		self.currentLabel = self.elem.nextElementSibling.querySelector('.js-card-carousel-current');
		self.totalLabel = self.elem.nextElementSibling.querySelector('.js-card-carousel-total');
		// bound versions created so we can bind 'this' and remove event listeners when flickity is destroyed.
		self.boundPrevSlide = self.prevSlide.bind(this);
		self.boundNextSlide = self.nextSlide.bind(this);

		self.totalLabel.innerHTML = self.elem.childElementCount;

		// Needs a delay as if there are any data tables on the page they take a little time to initialise
		// and in that time they will cause the screen width to overflow
		setTimeout(() => {
			if(self.getWindowWidth() < 859) {	
				self.setup();
			}
		}, 700);

		window.addEventListener("resize", () => {
			if(self.getWindowWidth() < 859 && self.flktyCarousel === null) {
				self.setup();
			} else if (self.getWindowWidth() >= 859 && self.flktyCarousel !== null) {
				self.destroy();
			}
		});
	}

	getWindowWidth() {
		return window.innerWidth || document.documentElement.clientWidth;
	}

	setup() {
		let self = this;

		self.setCurrentSlide(1);
	
		self.flktyCarousel = new Flickity(self.elem, {
			prevNextButtons: false,
			cellAlign: 'left',
			pageDots: false,
			on: {
				change: index => {
					self.setCurrentSlide(index + 1);
				}
			}
		});	
		
		self.setupNav();
	}

	setupNav() {
		let self = this;
		self.prevBtn.addEventListener('click', self.boundPrevSlide, true);

		self.nextBtn.addEventListener('click', self.boundNextSlide, true);
	}

	prevSlide(evt) {
		let self = this;
		evt.preventDefault();

		if(self.flktyCarousel) {
			console.log('prev');
			self.flktyCarousel.previous();
		}	
	}

	nextSlide(evt) {
		let self = this;
		evt.preventDefault();

		if(self.flktyCarousel) {
			self.flktyCarousel.next();
		}
	}

	setCurrentSlide(num) {
		let self = this;
		self.currentLabel.innerHTML = num;
	}

	destroy() {		
		let self = this;
		self.flktyCarousel.destroy();		
		self.flktyCarousel = null;
		self.prevBtn.removeEventListener('click', self.boundPrevSlide, true);
		self.nextBtn.removeEventListener('click', self.boundNextSlide, true);
	}
}

export default CardCarousel;